import moment from "moment";

export const PUSH_MESSAGE = "PUSH_MESSAGE";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";

export const messageType = {
    error: "error",
    message: "message",
};

/**
 * Pushes a message that will be displayed on the screen
 * @param {string} message
 * @param {string} messageType
 * @returns {function}
 */
export function pushSystemMessage(message,messageType=messageType.error) {
    return (dispatch) => {
        dispatch({
            type: PUSH_MESSAGE,
            date: moment.now(),
            messageType,
            message,
        });
    };
}

/**
 * Pushes a message that will be displayed on the screen
 * @param {number} index
 * @returns {function}
 */
export function removeSystemMessage(index) {
    return (dispatch) => {
        dispatch({
            type: REMOVE_MESSAGE,
            index,
        });
    };
}